import { z } from "zod"

// Version 1 ---------------------
export const TextElementV1 = z.object({
  id: z.string(),
  name: z.literal("text"),
  settings: z.object({
    isParagraph: z.union([z.literal(true), z.literal(false)]),
    initialStyles: z.object({}).passthrough().optional(),
    text: z.string(),
  }),
})

export type TTextElementV1 = z.infer<typeof TextElementV1>

// Latest ---------------------
export const TextElement = TextElementV1
export type TTextElement = TTextElementV1
